'use strict';exports.__esModule = true;exports.setUserLeadsAllowed = exports.sendViewLeadPhone = exports.setQuantityLoading = exports.setDensityUnreadLeads = exports.loadDensityUnreadLeads = exports.setCurrentPaginationStep = exports.loadUserLeads = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;
var loadUserLeads = (0, _reduxAct.createAction)('/LOAD_USER_LEADS');
var loadUserLeadsSuccess = (0, _reduxAct.createAction)('/LOAD_USER_LEADS_SUCCESS');
var loadUserLeadsFail = (0, _reduxAct.createAction)('/LOAD_USER_LEADS_FAIL');
var setCurrentPaginationStep = (0, _reduxAct.createAction)('/SET_CURRENT_PAGINATION_STEP');
var setDensityUnreadLeads = (0, _reduxAct.createAction)('/SET_DINSITY_UNREAL_LEADS');
var setQuantityLoading = (0, _reduxAct.createAction)('/SET_QUANTITY_LOADING');
var loadDensityUnreadLeads = (0, _reduxAct.createAction)('/LOAD_DENSITY_UNREAD_LEADS');
var loadDensityUnreadLeadsSuccess = (0, _reduxAct.createAction)('/LOAD_DENSITY_UNREAD_LEADS_SUCCESS');
var loadDensityUnreadLeadsFail = (0, _reduxAct.createAction)('/LOAD_DENSITY_UNREAD_LEADS_FAIl');
var sendViewLeadPhone = (0, _reduxAct.createAction)('/SEND_VIEW_LEAD_PHONE');
var sendViewLeadPhoneSuccess = (0, _reduxAct.createAction)('/SEND_VIEW_LEAD_PHONE_SUCCESS');
var sendViewLeadPhoneFail = (0, _reduxAct.createAction)('/SEND_VIEW_LEAD_PHONE_FAIL');
var setUserLeadsAllowed = (0, _reduxAct.createAction)('/SET_USER_LEADS_ALLOWED');

var initialState = {
  loaded: false,
  loading: false,
  numberUnreadLeads: null,
  quantityLoading: false,
  data: {},
  currentPaginationStep: 1 };


var fetchLoad = function fetchLoad(_ref) {var token = _ref.token,data = _ref.data,$sort = _ref.$sort;return (
    (0, _axios2.default)({
      method: 'get',
      url: '/leads',
      headers: {
        access_token: token },

      params: Object.assign({},
      data, {
        $sort: $sort || '-created_at' }) }).


    then(loadUserLeadsSuccess, loadUserLeadsFail));};

var handleLoad = function handleLoad(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchLoad, data));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref2) {var data = _ref2.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading user leads');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: {},
    error: error });

};

var handleSetCurrentPaginationStep = function handleSetCurrentPaginationStep(state, action) {
  if (action !== 0) {
    return Object.assign({},
    state, {
      currentPaginationStep: action });

  }
  return Object.assign({},
  state, {
    currentPaginationStep: NaN });

};

var submitViewLeadPhone = function submitViewLeadPhone(_ref3) {var id = _ref3.id,data = _ref3.data,token = _ref3.token;return _axios2.default.
  put('leads/' + id + '/view', data, { headers: { access_token: token } }).
  then(sendViewLeadPhoneSuccess, sendViewLeadPhoneFail);};

var handleViewLeadPhone = function handleViewLeadPhone(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true }),
  promise(submitViewLeadPhone, action));};

var handleViewLeadPhoneSuccess = function handleViewLeadPhoneSuccess(state, _ref4) {var data = _ref4.data;
  var newData = state.data.data.map(function (lead) {
    if (data.id === lead.id) {
      return data;
    }
    return lead;
  });
  return Object.assign({},
  state, {
    submitting: false,
    submitted: true,
    data: Object.assign({},
    state.data, {
      data: newData }),

    formError: null });

};

var handleLoadDensityUnreadLeadsSuccess = function handleLoadDensityUnreadLeadsSuccess(state, _ref5) {var data = _ref5.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    quantityLoading: true,
    numberUnreadLeads: data.total });};


var handleLoadDensityUnreadLeadsFail = function handleLoadDensityUnreadLeadsFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading unread leads');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    quantityLoading: false,
    numberUnreadLeads: null,
    error: error });

};

var handleLoadDensityUnreadLeads = function handleLoadDensityUnreadLeads(_ref6) {var token = _ref6.token;return (
    (0, _axios2.default)({
      method: 'get',
      url: '/leads/count/unviewed',
      headers: {
        access_token: token } }).


    then(loadDensityUnreadLeadsSuccess, loadDensityUnreadLeadsFail));};


var handleLoadDensityUnread = function handleLoadDensityUnread(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true, numberUnreadLeads: null }), promise(handleLoadDensityUnreadLeads, data)));};

var handleSetDensityUnreadLeads = function handleSetDensityUnreadLeads(state, action) {
  if (action !== 0) {
    return Object.assign({},
    state, {
      numberUnreadLeads: action });

  }

  return Object.assign({},
  state, {
    numberUnreadLeads: null });

};

var handleSetQuantityLoading = function handleSetQuantityLoading(state) {return Object.assign({},
  state, {
    quantityLoading: true,
    numberUnreadLeads: null });};



var handleViewLeadPhoneFail = function handleViewLeadPhoneFail(state, _ref7) {var response = _ref7.response;return Object.assign({},
  state, {
    submitting: false,
    submitted: false,
    formError: response.data });};


var handleUserLeadsAllowed = function handleUserLeadsAllowed(state, action) {return Object.assign({},
  state, {
    userLeadsAllowed: action });};


var leads = (0, _reduxAct.createReducer)(function (on) {
  on(loadUserLeads, handleLoad);
  on(loadUserLeadsSuccess, handleLoadSuccess);
  on(loadUserLeadsFail, handleLoadFail);
  on(loadDensityUnreadLeads, handleLoadDensityUnread);
  on(loadDensityUnreadLeadsSuccess, handleLoadDensityUnreadLeadsSuccess);
  on(loadDensityUnreadLeadsFail, handleLoadDensityUnreadLeadsFail);
  on(setCurrentPaginationStep, handleSetCurrentPaginationStep);
  on(setDensityUnreadLeads, handleSetDensityUnreadLeads);
  on(setQuantityLoading, handleSetQuantityLoading);
  on(sendViewLeadPhone, handleViewLeadPhone);
  on(sendViewLeadPhoneSuccess, handleViewLeadPhoneSuccess);
  on(sendViewLeadPhoneFail, handleViewLeadPhoneFail);
  on(setUserLeadsAllowed, handleUserLeadsAllowed);
}, initialState);exports.


loadUserLeads = loadUserLeads;exports.
setCurrentPaginationStep = setCurrentPaginationStep;exports.
loadDensityUnreadLeads = loadDensityUnreadLeads;exports.
setDensityUnreadLeads = setDensityUnreadLeads;exports.
setQuantityLoading = setQuantityLoading;exports.
sendViewLeadPhone = sendViewLeadPhone;exports.
setUserLeadsAllowed = setUserLeadsAllowed;exports.default =


leads;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/leads.js
// module id = 590
// module chunks = 0